import api from './api';

/**
 * List saved contacts (previously used recipients).
 * API: GET /api/contact-list?search=
 */
export const getContactList = async (params = {}) => {
  const response = await api.get('/contact-list', { params });
  return response.data;
};
